import { Box, Grid, Typography } from "@mui/material";
import styled from "styled-components";
import { loadLocalImage } from "../../../utils";

const backgroundSectionBase = `
  position: relative;
  height: 486px;
  width: 100%;
  overflow: hidden;
  background-repeat: no-repeat;
  background-size: cover;
  transition: transform 0.3s ease;
`;

export const LeftImage = styled.div`
  ${backgroundSectionBase}
  background-image: url(${loadLocalImage("individual.png")});
  background-position: center right;
`;

export const RightImage = styled.div`
  ${backgroundSectionBase}
  background-image: url(${loadLocalImage("empresarial.png")});
  background-position: center left;
`;

export const Title = styled(Typography).attrs({ as: "h2" })`
  && {
    margin: 0 0 20px;
    font-family: Figtree, sans-serif;
    font-weight: 700;
    font-size: clamp(26px, 2vw + 16px, 32px);
    line-height: 1.2;
    color: #ffffff;
    text-align: center;
  }
`;

export const Subtitle = styled(Typography)`
  && {
    margin: 20px;
    font-family: Figtree, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: clamp(16px, 1vw + 12px, 20px);
    line-height: 1.3;
    color: #ffffff;
    text-align: center;
  }
`;

export const Wrapper = styled(Box)`
  && {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 10;

    width: min(100%, 500px);
    padding: 0 10px;
    text-align: center;
  }
`;

export const WrapperLeft = styled(Wrapper)`
  && {
    right: 0;

    @media (max-width: 900px) {
      left: 50%;
      right: auto;
      transform: translate(-50%, -50%);
    }
  }
`;

export const WrapperRight = styled(Wrapper)`
  && {
    left: 0;

    @media (max-width: 900px) {
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
`;

export const StyledGrid = styled(Grid)`
  && {
    position: relative;
    overflow: hidden;

    &:hover ${LeftImage},
    &:hover ${RightImage} {
      transform: scale(1.06);
    }
  }
`;

export const CorrectorBox = styled(Box)`
  && {
    position: relative;
    z-index: 10;

    margin: -48px auto 0;
    max-width: 724px;
    min-height: 98px;
    background: #ffffff;
    border-radius: 10px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
  }
`;

export const CorrectorTitle = styled(Typography).attrs({ as: "p" })`
  && {
    margin: 0;
    font-family: Figtree, sans-serif;
    font-size: 21px;
    font-style: normal;
    font-weight: 400;
    text-align: center;
    color: #7e7e7e;
  }
`;

export const CorrectorSubtitle = styled(CorrectorTitle)`
  && {
    text-transform: uppercase;
    color: #ed6d04;
  }
`;

export const CorrectorWrapper = styled(Box)`
  && {
    display: inline-flex;
    flex-direction: column;
    justify-content: center;
    min-height: 98px;
    padding: 15px;
  }
`;
